import React, { Fragment, useEffect, useRef, useState } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import IsGated, { useGate } from "apps/dna/is-gated";
import EmmaController from "./emma/emma-controller";
import PlatformManagementController from "./platform-management/platform-management-controller";
import { Nav, NavItem } from "../../style/components/nav-tabs";
import { Layout, Loading } from "@evertrue/et-components";
import TitleHeader from "../../components/title-header";
import CrmController from "./crm/crm-controller";
import { DonorSearchIntegration } from "./crm/integration-cards/donorsearch-integration";
import Api from "utils/api";

const Integrations = () => {
  const { show: emmaEnabled } = useGate("emma");
  const [donorSearchData, setDonorSearchData] = useState(null);
  const [donorSearchAvailable, setDonorSearchAvailable] = useState(false);
  const [donorSearchLoading, setDonorSearchLoading] = useState(true);
  const hasFetchedDS = useRef(false);

  useEffect(() => {
    if (hasFetchedDS.current) return;
    hasFetchedDS.current = true;
    const fetchDonorSearch = async () => {
      try {
        const { data } = await Api.DONOR_SEARCH.INTEGRATION.get({ disableAlerts: true });
        setDonorSearchData(data);
        setDonorSearchAvailable(data && data.configured === true);
      } catch (e) {
        setDonorSearchAvailable(false);
      } finally {
        setDonorSearchLoading(false);
      }
    };
    fetchDonorSearch();
  }, []);

  const header = (
    <Fragment>
      <TitleHeader title="Integrations" subtitle="Settings for Integrations" />
      <Nav>
        <IsGated gate="emma">
          <NavItem activeClassName="active" to="/integrations/emma">
            Emma
          </NavItem>
        </IsGated>
        <IsGated gate="meeting_platforms">
          <NavItem
            activeClassName="active"
            to="/integrations/platform-management"
          >
            Meeting Platforms
          </NavItem>
        </IsGated>
        <IsGated gate="crm_integrations">
          <NavItem activeClassName="active" to="/integrations/crm">
            CRM
          </NavItem>
        </IsGated>
        {donorSearchAvailable && (
          <NavItem activeClassName="active" to="/integrations/donor-search">
            Donor Search
          </NavItem>
        )}
      </Nav>
    </Fragment>
  );

  return (
    <Layout header={header} headerBorder={false}>
      <Switch>
        {emmaEnabled && (
          <Route path="/integrations/emma">
            <EmmaController />
          </Route>
        )}
        <Route path="/integrations/platform-management">
          <PlatformManagementController />
        </Route>
        <Route path="/integrations/crm">
          <CrmController />
        </Route>
        <Route path="/integrations/donor-search">
          {donorSearchLoading ? (
            <Loading />
          ) : donorSearchAvailable ? (
            <DonorSearchIntegration initialData={donorSearchData} />
          ) : (
            <Redirect to="/integrations" />
          )}
        </Route>
      </Switch>
    </Layout>
  );
};

export default Integrations;
